<template>
  <div :class="[{ player__lite: lite == true }, 'player']">
    <div class="player__content">
      <template v-if="hasLoaded">
        <div
          v-if="lite == false"
          :class="[{ overlayOpen: overlayToShow }, 'player__image']"
        >
          <player-image
            :imagePath="episode.image"
            :alt="podcast.title"
            :overlayOpen="!!overlayToShow"
            @launchWebsite="launchWebsite"
            @toggleShowNotes="toggleShowNotes"
          />
        </div>
        <transition name="fade-up">
          <div class="player__overlay" v-if="overlayToShow">
            <details-overlay
              v-if="overlayToShow === 'details'"
              :episode="episode"
              :podcast="podcast"
            />
            <share-overlay
              v-if="overlayToShow === 'share'"
              :episode="episode"
              :podcast="podcast"
              :currentTimestamp="player.currentTime"
            />
            <subscribe-overlay
              v-if="overlayToShow === 'subscribe'"
              :episode="episode"
              :podcast="podcast"
            />
          </div>
        </transition>
        <div class="player__body">
          <div class="player__details">
            <player-play
              :isPlaying="isPlaying"
              @togglePlayback="togglePlayback"
            />
            <player-details :episode="episode" :podcast="podcast" />
          </div>
          <audio controls ref="player" preload="none">
            <source
              :src="
                `${episode.downloadPath}?source=embed-play&referer=${referer}`
              "
              type="audio/mp3"
            />
          </audio>
        </div>
        <div
          v-if="lite == false"
          :class="[{ overlayOpen: overlayToShow }, 'player__actions']"
        >
          <player-actions
            :episode="episode"
            :overlayOpen="!!overlayToShow"
            @closeOverlay="closeOverlay"
            @onShowNotes="overlayToShow = 'details'"
            @onShare="overlayToShow = 'share'"
            @onSubscribe="overlayToShow = 'subscribe'"
          />
        </div>
      </template>
      <template v-else>
        <div class="loading-wrapper">
          <template v-if="error == 404">
            <h2>🥺 Ooops! Nothing here 🥺</h2>
            <p>This episode or show hasn't been published or doesn't exist.</p>
            <a
              href="https://www.zencast.fm/?utm_source=embedded%20player&utm_medium=embedded%20player&utm_campaign=embedded%20player"
              target="_blank"
            >
              <svg viewBox="0 0 679 213.43" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:class="'logo'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M275.63 98.83h-26.95V86.06h45.74v12.77l-28.13 31.09h28.96v12.77h-47.64v-12.77l28.02-31.09zM332.85 144.45c-8.63 0-15.84-2.96-21.63-8.75-5.79-5.79-8.63-12.88-8.63-21.28s2.72-15.49 8.15-21.28c5.44-5.79 12.29-8.75 20.45-8.75s14.89 2.72 20.33 8.27c5.44 5.55 8.16 12.41 8.16 20.57 0 2.25-.12 3.78-.35 4.73h-41.96c.71 4.02 2.48 7.33 5.44 9.81 2.96 2.48 6.5 3.78 10.76 3.78 5.44 0 10.05-2.01 13.83-5.91l7.45 9.81c-2.25 2.6-5.32 4.73-9.22 6.38-3.9 1.65-8.16 2.48-12.77 2.48v.14zm-1.66-47.51c-3.55 0-6.5 1.06-8.86 3.31s-4.02 5.2-4.85 8.87h27.3c-.83-3.9-2.36-6.98-4.73-9.1-2.36-2.13-5.32-3.19-8.75-3.19l-.11.11zM386.4 142.92h-14.42V86.3h14.42v5.56c3.66-4.85 8.98-7.21 15.96-7.21 6.5 0 11.7 2.13 15.6 6.38 3.9 4.25 5.91 10.05 5.91 17.49v34.28h-14.42v-32.15c0-3.9-1.06-6.98-3.19-9.22S401.41 98 397.99 98c-3.66 0-6.5 1.06-8.51 3.31s-3.07 5.32-3.07 9.22v32.39zM480.38 103.55c-3.66-3.43-8.15-5.2-13.47-5.2-4.61 0-8.39 1.54-11.35 4.61-2.96 3.08-4.37 6.98-4.37 11.59s1.54 8.51 4.49 11.7c2.96 3.19 6.74 4.73 11.35 4.73 5.56 0 10.17-1.89 13.83-5.56l7.33 10.64c-2.25 2.48-5.32 4.49-9.22 6.03-3.9 1.54-8.04 2.36-12.41 2.36-8.39 0-15.48-2.96-21.28-8.75-5.79-5.79-8.63-12.88-8.63-21.16s2.84-15.37 8.51-21.28c5.67-5.91 12.65-8.87 20.92-8.87 9.46 0 16.9 2.84 22.34 8.51l-8.27 10.28.23.37zM537.24 136.65c-4.37 5.2-10.16 7.8-17.26 7.8-7.68 0-14.07-2.83-19.27-8.51-5.2-5.67-7.8-12.88-7.8-21.51s2.6-15.84 7.8-21.51c5.2-5.67 11.7-8.51 19.5-8.51 7.21 0 13 2.48 17.26 7.33v-5.68h14.54v56.62h-14.54l-.23-6.03zm-15.01-5.67c4.25 0 7.8-1.66 10.64-4.85 2.84-3.19 4.25-7.09 4.25-11.7s-1.42-8.51-4.25-11.7c-2.84-3.19-6.38-4.73-10.64-4.73-4.37 0-7.92 1.54-10.76 4.73-2.84 3.19-4.25 7.09-4.25 11.7s1.42 8.51 4.25 11.7c2.84 3.19 6.5 4.73 10.87 4.73l-.11.12zM580.03 101.55c0 1.77 1.06 3.19 3.19 4.25 2.13 1.07 4.73 2.01 7.68 2.84 2.95.83 5.91 1.77 8.86 2.84 2.96 1.06 5.56 2.84 7.68 5.44 2.13 2.6 3.19 5.79 3.19 9.69 0 5.08-2.01 9.34-6.15 12.77-4.14 3.43-9.93 5.08-17.38 5.08-10.4 0-18.32-3.19-23.76-9.57l8.04-9.22c4.37 4.85 9.93 7.21 16.67 7.21 2.72 0 4.85-.59 6.27-1.65 1.42-1.07 2.13-2.48 2.13-4.26 0-1.54-.71-2.84-2.25-3.9s-3.43-1.89-5.67-2.48c-2.25-.59-4.73-1.42-7.33-2.36-2.6-.95-5.08-2.01-7.33-3.19-2.25-1.18-4.14-2.95-5.67-5.32-1.54-2.36-2.25-5.08-2.25-8.27 0-4.61 1.89-8.63 5.67-11.94 3.78-3.31 9.1-4.97 15.96-4.97 10.52 0 17.97 3.07 22.46 9.34l-8.15 8.51c-3.55-4.14-8.16-6.27-13.95-6.27-2.48 0-4.37.47-5.79 1.42s-2.13 2.25-2.13 3.78v.23zM617.27 86.06h10.05V71.41h14.42v14.66h15.37v12.77h-15.25v24c0 5.32 2.13 7.92 6.5 7.92 2.72 0 4.96-.94 6.62-2.84l6.5 10.76c-3.9 3.78-9.1 5.67-15.48 5.67-5.79 0-10.4-1.77-13.71-5.44-3.31-3.66-4.96-8.87-4.96-15.6V98.83h-9.93l-.13-12.77z"/><g><path d="M157.35 193.48c-1.74 0-3.43-.88-4.4-2.47a5.146 5.146 0 011.71-7.07 84.105 84.105 0 0015.6-12.29c32.53-32.53 32.53-85.47 0-118.01-16.5-16.5-38.45-25.17-61.77-24.4-2.8.06-5.22-2.13-5.31-4.97-.09-2.84 2.13-5.22 4.97-5.31 25.82-.85 51.12 9.14 69.39 27.4 36.55 36.55 36.55 96.02 0 132.56-5.3 5.29-11.19 9.94-17.52 13.8-.83.52-1.76.76-2.67.76zM23.21 127.66c-2.59 0-4.81-1.95-5.11-4.58-3.17-28.5 6.62-56.46 26.87-76.71 10.53-10.51 22.97-18.18 37-22.78 2.7-.89 5.61.58 6.49 3.28.89 2.7-.59 5.61-3.28 6.49-12.48 4.1-23.56 10.92-32.92 20.29-18.03 18.03-26.75 42.93-23.92 68.3.31 2.82-1.72 5.37-4.54 5.68-.2.02-.4.03-.59.03zM44.59 176.14c-1.43 0-2.85-.59-3.87-1.75a93.137 93.137 0 01-16.39-26.61 5.15 5.15 0 012.85-6.7 5.15 5.15 0 016.7 2.85c3.49 8.66 8.4 16.62 14.58 23.67a5.144 5.144 0 01-.48 7.26c-.97.86-2.18 1.28-3.39 1.28zM66.92 194.52c-.87 0-1.76-.22-2.57-.69a94.052 94.052 0 01-6.38-4.05 5.14 5.14 0 01-1.3-7.16 5.14 5.14 0 017.16-1.3 83.46 83.46 0 005.67 3.6 5.147 5.147 0 011.88 7.03 5.134 5.134 0 01-4.46 2.57z"/><path d="M141.94 182.07c-1.92 0-3.76-1.08-4.65-2.93-1.22-2.56-.14-5.64 2.43-6.86 6.76-3.23 12.9-7.57 18.25-12.92 25.75-25.75 25.75-67.66 0-93.41s-67.66-25.76-93.41 0c-5.61 5.61-10.11 12.07-13.37 19.21a5.144 5.144 0 01-6.82 2.54 5.153 5.153 0 01-2.54-6.82c3.78-8.26 8.98-15.73 15.45-22.21 29.77-29.76 78.2-29.76 107.96 0 29.77 29.77 29.77 78.2 0 107.96a76.116 76.116 0 01-21.1 14.93c-.7.35-1.46.51-2.2.51zM46.51 147.44c-1.95 0-3.82-1.11-4.68-3.01-5.51-12.04-7.79-25.41-6.6-38.67.26-2.83 2.77-4.93 5.59-4.66a5.14 5.14 0 014.66 5.59c-1.03 11.47.94 23.04 5.71 33.46 1.18 2.58.05 5.64-2.54 6.82-.69.32-1.42.47-2.14.47zM82.03 182.74c-.71 0-1.42-.15-2.11-.45-8.43-3.79-16.05-9.06-22.64-15.65-.69-.69-1.36-1.38-2.01-2.09a5.14 5.14 0 01.28-7.27 5.14 5.14 0 017.27.28c.57.61 1.15 1.21 1.74 1.81 5.7 5.7 12.29 10.26 19.58 13.54 2.59 1.17 3.75 4.21 2.58 6.8a5.139 5.139 0 01-4.69 3.03z"/><path d="M159.26 138.24c-.67 0-1.35-.13-2.01-.41a5.15 5.15 0 01-2.72-6.75c7.55-17.75 3.62-38.03-10.02-51.67-16.26-16.26-42.47-18.29-60.98-4.72a5.146 5.146 0 01-6.08-8.3c22.57-16.54 54.53-14.07 74.34 5.75 16.62 16.62 21.42 41.34 12.22 62.98a5.19 5.19 0 01-4.75 3.12zM65.72 143.25c-1.8 0-3.55-.95-4.49-2.63-9.38-16.77-9.75-36.99-.98-54.1 1.3-2.53 4.4-3.53 6.93-2.23 2.53 1.3 3.53 4.4 2.23 6.93a46.919 46.919 0 00.8 44.38c1.39 2.48.5 5.61-1.98 7-.79.44-1.66.65-2.51.65z"/></g></svg>
            </a>
          </template>
          <template v-else-if="error == 403">
            <h2>🕵️ This podcast is private 🕵️</h2>
            <p>
              To listen to this podcast its publisher must invite you to listen.
            </p>
            <a
              href="https://www.zencast.fm/?utm_source=embedded%20player&utm_medium=embedded%20player&utm_campaign=embedded%20player"
              target="_blank"
            >
              <svg viewBox="0 0 679 213.43" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:class="'logo'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M275.63 98.83h-26.95V86.06h45.74v12.77l-28.13 31.09h28.96v12.77h-47.64v-12.77l28.02-31.09zM332.85 144.45c-8.63 0-15.84-2.96-21.63-8.75-5.79-5.79-8.63-12.88-8.63-21.28s2.72-15.49 8.15-21.28c5.44-5.79 12.29-8.75 20.45-8.75s14.89 2.72 20.33 8.27c5.44 5.55 8.16 12.41 8.16 20.57 0 2.25-.12 3.78-.35 4.73h-41.96c.71 4.02 2.48 7.33 5.44 9.81 2.96 2.48 6.5 3.78 10.76 3.78 5.44 0 10.05-2.01 13.83-5.91l7.45 9.81c-2.25 2.6-5.32 4.73-9.22 6.38-3.9 1.65-8.16 2.48-12.77 2.48v.14zm-1.66-47.51c-3.55 0-6.5 1.06-8.86 3.31s-4.02 5.2-4.85 8.87h27.3c-.83-3.9-2.36-6.98-4.73-9.1-2.36-2.13-5.32-3.19-8.75-3.19l-.11.11zM386.4 142.92h-14.42V86.3h14.42v5.56c3.66-4.85 8.98-7.21 15.96-7.21 6.5 0 11.7 2.13 15.6 6.38 3.9 4.25 5.91 10.05 5.91 17.49v34.28h-14.42v-32.15c0-3.9-1.06-6.98-3.19-9.22S401.41 98 397.99 98c-3.66 0-6.5 1.06-8.51 3.31s-3.07 5.32-3.07 9.22v32.39zM480.38 103.55c-3.66-3.43-8.15-5.2-13.47-5.2-4.61 0-8.39 1.54-11.35 4.61-2.96 3.08-4.37 6.98-4.37 11.59s1.54 8.51 4.49 11.7c2.96 3.19 6.74 4.73 11.35 4.73 5.56 0 10.17-1.89 13.83-5.56l7.33 10.64c-2.25 2.48-5.32 4.49-9.22 6.03-3.9 1.54-8.04 2.36-12.41 2.36-8.39 0-15.48-2.96-21.28-8.75-5.79-5.79-8.63-12.88-8.63-21.16s2.84-15.37 8.51-21.28c5.67-5.91 12.65-8.87 20.92-8.87 9.46 0 16.9 2.84 22.34 8.51l-8.27 10.28.23.37zM537.24 136.65c-4.37 5.2-10.16 7.8-17.26 7.8-7.68 0-14.07-2.83-19.27-8.51-5.2-5.67-7.8-12.88-7.8-21.51s2.6-15.84 7.8-21.51c5.2-5.67 11.7-8.51 19.5-8.51 7.21 0 13 2.48 17.26 7.33v-5.68h14.54v56.62h-14.54l-.23-6.03zm-15.01-5.67c4.25 0 7.8-1.66 10.64-4.85 2.84-3.19 4.25-7.09 4.25-11.7s-1.42-8.51-4.25-11.7c-2.84-3.19-6.38-4.73-10.64-4.73-4.37 0-7.92 1.54-10.76 4.73-2.84 3.19-4.25 7.09-4.25 11.7s1.42 8.51 4.25 11.7c2.84 3.19 6.5 4.73 10.87 4.73l-.11.12zM580.03 101.55c0 1.77 1.06 3.19 3.19 4.25 2.13 1.07 4.73 2.01 7.68 2.84 2.95.83 5.91 1.77 8.86 2.84 2.96 1.06 5.56 2.84 7.68 5.44 2.13 2.6 3.19 5.79 3.19 9.69 0 5.08-2.01 9.34-6.15 12.77-4.14 3.43-9.93 5.08-17.38 5.08-10.4 0-18.32-3.19-23.76-9.57l8.04-9.22c4.37 4.85 9.93 7.21 16.67 7.21 2.72 0 4.85-.59 6.27-1.65 1.42-1.07 2.13-2.48 2.13-4.26 0-1.54-.71-2.84-2.25-3.9s-3.43-1.89-5.67-2.48c-2.25-.59-4.73-1.42-7.33-2.36-2.6-.95-5.08-2.01-7.33-3.19-2.25-1.18-4.14-2.95-5.67-5.32-1.54-2.36-2.25-5.08-2.25-8.27 0-4.61 1.89-8.63 5.67-11.94 3.78-3.31 9.1-4.97 15.96-4.97 10.52 0 17.97 3.07 22.46 9.34l-8.15 8.51c-3.55-4.14-8.16-6.27-13.95-6.27-2.48 0-4.37.47-5.79 1.42s-2.13 2.25-2.13 3.78v.23zM617.27 86.06h10.05V71.41h14.42v14.66h15.37v12.77h-15.25v24c0 5.32 2.13 7.92 6.5 7.92 2.72 0 4.96-.94 6.62-2.84l6.5 10.76c-3.9 3.78-9.1 5.67-15.48 5.67-5.79 0-10.4-1.77-13.71-5.44-3.31-3.66-4.96-8.87-4.96-15.6V98.83h-9.93l-.13-12.77z"/><g><path d="M157.35 193.48c-1.74 0-3.43-.88-4.4-2.47a5.146 5.146 0 011.71-7.07 84.105 84.105 0 0015.6-12.29c32.53-32.53 32.53-85.47 0-118.01-16.5-16.5-38.45-25.17-61.77-24.4-2.8.06-5.22-2.13-5.31-4.97-.09-2.84 2.13-5.22 4.97-5.31 25.82-.85 51.12 9.14 69.39 27.4 36.55 36.55 36.55 96.02 0 132.56-5.3 5.29-11.19 9.94-17.52 13.8-.83.52-1.76.76-2.67.76zM23.21 127.66c-2.59 0-4.81-1.95-5.11-4.58-3.17-28.5 6.62-56.46 26.87-76.71 10.53-10.51 22.97-18.18 37-22.78 2.7-.89 5.61.58 6.49 3.28.89 2.7-.59 5.61-3.28 6.49-12.48 4.1-23.56 10.92-32.92 20.29-18.03 18.03-26.75 42.93-23.92 68.3.31 2.82-1.72 5.37-4.54 5.68-.2.02-.4.03-.59.03zM44.59 176.14c-1.43 0-2.85-.59-3.87-1.75a93.137 93.137 0 01-16.39-26.61 5.15 5.15 0 012.85-6.7 5.15 5.15 0 016.7 2.85c3.49 8.66 8.4 16.62 14.58 23.67a5.144 5.144 0 01-.48 7.26c-.97.86-2.18 1.28-3.39 1.28zM66.92 194.52c-.87 0-1.76-.22-2.57-.69a94.052 94.052 0 01-6.38-4.05 5.14 5.14 0 01-1.3-7.16 5.14 5.14 0 017.16-1.3 83.46 83.46 0 005.67 3.6 5.147 5.147 0 011.88 7.03 5.134 5.134 0 01-4.46 2.57z"/><path d="M141.94 182.07c-1.92 0-3.76-1.08-4.65-2.93-1.22-2.56-.14-5.64 2.43-6.86 6.76-3.23 12.9-7.57 18.25-12.92 25.75-25.75 25.75-67.66 0-93.41s-67.66-25.76-93.41 0c-5.61 5.61-10.11 12.07-13.37 19.21a5.144 5.144 0 01-6.82 2.54 5.153 5.153 0 01-2.54-6.82c3.78-8.26 8.98-15.73 15.45-22.21 29.77-29.76 78.2-29.76 107.96 0 29.77 29.77 29.77 78.2 0 107.96a76.116 76.116 0 01-21.1 14.93c-.7.35-1.46.51-2.2.51zM46.51 147.44c-1.95 0-3.82-1.11-4.68-3.01-5.51-12.04-7.79-25.41-6.6-38.67.26-2.83 2.77-4.93 5.59-4.66a5.14 5.14 0 014.66 5.59c-1.03 11.47.94 23.04 5.71 33.46 1.18 2.58.05 5.64-2.54 6.82-.69.32-1.42.47-2.14.47zM82.03 182.74c-.71 0-1.42-.15-2.11-.45-8.43-3.79-16.05-9.06-22.64-15.65-.69-.69-1.36-1.38-2.01-2.09a5.14 5.14 0 01.28-7.27 5.14 5.14 0 017.27.28c.57.61 1.15 1.21 1.74 1.81 5.7 5.7 12.29 10.26 19.58 13.54 2.59 1.17 3.75 4.21 2.58 6.8a5.139 5.139 0 01-4.69 3.03z"/><path d="M159.26 138.24c-.67 0-1.35-.13-2.01-.41a5.15 5.15 0 01-2.72-6.75c7.55-17.75 3.62-38.03-10.02-51.67-16.26-16.26-42.47-18.29-60.98-4.72a5.146 5.146 0 01-6.08-8.3c22.57-16.54 54.53-14.07 74.34 5.75 16.62 16.62 21.42 41.34 12.22 62.98a5.19 5.19 0 01-4.75 3.12zM65.72 143.25c-1.8 0-3.55-.95-4.49-2.63-9.38-16.77-9.75-36.99-.98-54.1 1.3-2.53 4.4-3.53 6.93-2.23 2.53 1.3 3.53 4.4 2.23 6.93a46.919 46.919 0 00.8 44.38c1.39 2.48.5 5.61-1.98 7-.79.44-1.66.65-2.51.65z"/></g></svg>
            </a>
          </template>
          <template v-else-if="error">
            <p>An error occured loading player.</p>
          </template>
          <template v-else>
            <div class="loader"></div>
            <a
              href="https://www.zencast.fm/?utm_source=embedded%20player&utm_medium=embedded%20player&utm_campaign=embedded%20player"
              target="_blank"
            >
              <svg viewBox="0 0 679 213.43" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:class="'logo'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M275.63 98.83h-26.95V86.06h45.74v12.77l-28.13 31.09h28.96v12.77h-47.64v-12.77l28.02-31.09zM332.85 144.45c-8.63 0-15.84-2.96-21.63-8.75-5.79-5.79-8.63-12.88-8.63-21.28s2.72-15.49 8.15-21.28c5.44-5.79 12.29-8.75 20.45-8.75s14.89 2.72 20.33 8.27c5.44 5.55 8.16 12.41 8.16 20.57 0 2.25-.12 3.78-.35 4.73h-41.96c.71 4.02 2.48 7.33 5.44 9.81 2.96 2.48 6.5 3.78 10.76 3.78 5.44 0 10.05-2.01 13.83-5.91l7.45 9.81c-2.25 2.6-5.32 4.73-9.22 6.38-3.9 1.65-8.16 2.48-12.77 2.48v.14zm-1.66-47.51c-3.55 0-6.5 1.06-8.86 3.31s-4.02 5.2-4.85 8.87h27.3c-.83-3.9-2.36-6.98-4.73-9.1-2.36-2.13-5.32-3.19-8.75-3.19l-.11.11zM386.4 142.92h-14.42V86.3h14.42v5.56c3.66-4.85 8.98-7.21 15.96-7.21 6.5 0 11.7 2.13 15.6 6.38 3.9 4.25 5.91 10.05 5.91 17.49v34.28h-14.42v-32.15c0-3.9-1.06-6.98-3.19-9.22S401.41 98 397.99 98c-3.66 0-6.5 1.06-8.51 3.31s-3.07 5.32-3.07 9.22v32.39zM480.38 103.55c-3.66-3.43-8.15-5.2-13.47-5.2-4.61 0-8.39 1.54-11.35 4.61-2.96 3.08-4.37 6.98-4.37 11.59s1.54 8.51 4.49 11.7c2.96 3.19 6.74 4.73 11.35 4.73 5.56 0 10.17-1.89 13.83-5.56l7.33 10.64c-2.25 2.48-5.32 4.49-9.22 6.03-3.9 1.54-8.04 2.36-12.41 2.36-8.39 0-15.48-2.96-21.28-8.75-5.79-5.79-8.63-12.88-8.63-21.16s2.84-15.37 8.51-21.28c5.67-5.91 12.65-8.87 20.92-8.87 9.46 0 16.9 2.84 22.34 8.51l-8.27 10.28.23.37zM537.24 136.65c-4.37 5.2-10.16 7.8-17.26 7.8-7.68 0-14.07-2.83-19.27-8.51-5.2-5.67-7.8-12.88-7.8-21.51s2.6-15.84 7.8-21.51c5.2-5.67 11.7-8.51 19.5-8.51 7.21 0 13 2.48 17.26 7.33v-5.68h14.54v56.62h-14.54l-.23-6.03zm-15.01-5.67c4.25 0 7.8-1.66 10.64-4.85 2.84-3.19 4.25-7.09 4.25-11.7s-1.42-8.51-4.25-11.7c-2.84-3.19-6.38-4.73-10.64-4.73-4.37 0-7.92 1.54-10.76 4.73-2.84 3.19-4.25 7.09-4.25 11.7s1.42 8.51 4.25 11.7c2.84 3.19 6.5 4.73 10.87 4.73l-.11.12zM580.03 101.55c0 1.77 1.06 3.19 3.19 4.25 2.13 1.07 4.73 2.01 7.68 2.84 2.95.83 5.91 1.77 8.86 2.84 2.96 1.06 5.56 2.84 7.68 5.44 2.13 2.6 3.19 5.79 3.19 9.69 0 5.08-2.01 9.34-6.15 12.77-4.14 3.43-9.93 5.08-17.38 5.08-10.4 0-18.32-3.19-23.76-9.57l8.04-9.22c4.37 4.85 9.93 7.21 16.67 7.21 2.72 0 4.85-.59 6.27-1.65 1.42-1.07 2.13-2.48 2.13-4.26 0-1.54-.71-2.84-2.25-3.9s-3.43-1.89-5.67-2.48c-2.25-.59-4.73-1.42-7.33-2.36-2.6-.95-5.08-2.01-7.33-3.19-2.25-1.18-4.14-2.95-5.67-5.32-1.54-2.36-2.25-5.08-2.25-8.27 0-4.61 1.89-8.63 5.67-11.94 3.78-3.31 9.1-4.97 15.96-4.97 10.52 0 17.97 3.07 22.46 9.34l-8.15 8.51c-3.55-4.14-8.16-6.27-13.95-6.27-2.48 0-4.37.47-5.79 1.42s-2.13 2.25-2.13 3.78v.23zM617.27 86.06h10.05V71.41h14.42v14.66h15.37v12.77h-15.25v24c0 5.32 2.13 7.92 6.5 7.92 2.72 0 4.96-.94 6.62-2.84l6.5 10.76c-3.9 3.78-9.1 5.67-15.48 5.67-5.79 0-10.4-1.77-13.71-5.44-3.31-3.66-4.96-8.87-4.96-15.6V98.83h-9.93l-.13-12.77z"/><g><path d="M157.35 193.48c-1.74 0-3.43-.88-4.4-2.47a5.146 5.146 0 011.71-7.07 84.105 84.105 0 0015.6-12.29c32.53-32.53 32.53-85.47 0-118.01-16.5-16.5-38.45-25.17-61.77-24.4-2.8.06-5.22-2.13-5.31-4.97-.09-2.84 2.13-5.22 4.97-5.31 25.82-.85 51.12 9.14 69.39 27.4 36.55 36.55 36.55 96.02 0 132.56-5.3 5.29-11.19 9.94-17.52 13.8-.83.52-1.76.76-2.67.76zM23.21 127.66c-2.59 0-4.81-1.95-5.11-4.58-3.17-28.5 6.62-56.46 26.87-76.71 10.53-10.51 22.97-18.18 37-22.78 2.7-.89 5.61.58 6.49 3.28.89 2.7-.59 5.61-3.28 6.49-12.48 4.1-23.56 10.92-32.92 20.29-18.03 18.03-26.75 42.93-23.92 68.3.31 2.82-1.72 5.37-4.54 5.68-.2.02-.4.03-.59.03zM44.59 176.14c-1.43 0-2.85-.59-3.87-1.75a93.137 93.137 0 01-16.39-26.61 5.15 5.15 0 012.85-6.7 5.15 5.15 0 016.7 2.85c3.49 8.66 8.4 16.62 14.58 23.67a5.144 5.144 0 01-.48 7.26c-.97.86-2.18 1.28-3.39 1.28zM66.92 194.52c-.87 0-1.76-.22-2.57-.69a94.052 94.052 0 01-6.38-4.05 5.14 5.14 0 01-1.3-7.16 5.14 5.14 0 017.16-1.3 83.46 83.46 0 005.67 3.6 5.147 5.147 0 011.88 7.03 5.134 5.134 0 01-4.46 2.57z"/><path d="M141.94 182.07c-1.92 0-3.76-1.08-4.65-2.93-1.22-2.56-.14-5.64 2.43-6.86 6.76-3.23 12.9-7.57 18.25-12.92 25.75-25.75 25.75-67.66 0-93.41s-67.66-25.76-93.41 0c-5.61 5.61-10.11 12.07-13.37 19.21a5.144 5.144 0 01-6.82 2.54 5.153 5.153 0 01-2.54-6.82c3.78-8.26 8.98-15.73 15.45-22.21 29.77-29.76 78.2-29.76 107.96 0 29.77 29.77 29.77 78.2 0 107.96a76.116 76.116 0 01-21.1 14.93c-.7.35-1.46.51-2.2.51zM46.51 147.44c-1.95 0-3.82-1.11-4.68-3.01-5.51-12.04-7.79-25.41-6.6-38.67.26-2.83 2.77-4.93 5.59-4.66a5.14 5.14 0 014.66 5.59c-1.03 11.47.94 23.04 5.71 33.46 1.18 2.58.05 5.64-2.54 6.82-.69.32-1.42.47-2.14.47zM82.03 182.74c-.71 0-1.42-.15-2.11-.45-8.43-3.79-16.05-9.06-22.64-15.65-.69-.69-1.36-1.38-2.01-2.09a5.14 5.14 0 01.28-7.27 5.14 5.14 0 017.27.28c.57.61 1.15 1.21 1.74 1.81 5.7 5.7 12.29 10.26 19.58 13.54 2.59 1.17 3.75 4.21 2.58 6.8a5.139 5.139 0 01-4.69 3.03z"/><path d="M159.26 138.24c-.67 0-1.35-.13-2.01-.41a5.15 5.15 0 01-2.72-6.75c7.55-17.75 3.62-38.03-10.02-51.67-16.26-16.26-42.47-18.29-60.98-4.72a5.146 5.146 0 01-6.08-8.3c22.57-16.54 54.53-14.07 74.34 5.75 16.62 16.62 21.42 41.34 12.22 62.98a5.19 5.19 0 01-4.75 3.12zM65.72 143.25c-1.8 0-3.55-.95-4.49-2.63-9.38-16.77-9.75-36.99-.98-54.1 1.3-2.53 4.4-3.53 6.93-2.23 2.53 1.3 3.53 4.4 2.23 6.93a46.919 46.919 0 00.8 44.38c1.39 2.48.5 5.61-1.98 7-.79.44-1.66.65-2.51.65z"/></g></svg>
            </a>
          </template>
        </div>
      </template>
    </div>
    <div v-if="isPodcastEmbed && hasLoaded" class="player__episodes">
      <player-episodes
        :podcast="podcast"
        :episode="episode"
        :is-playing="isPlaying"
        @episodeSelected="updateEpisode"
      />
    </div>
  </div>
</template>

<script>
import Plyr from "plyr";

import Api from "@/lib/ApiClient";

import PlayerImage from "@/components/player/PlayerImage";
import PlayerPlay from "@/components/player/PlayerPlay";
import PlayerDetails from "@/components/player/PlayerDetails";
import PlayerActions from "@/components/player/PlayerActions";
import PlayerEpisodes from "@/components/player/PlayerEpisodes";
import DetailsOverlay from "@/components/player/DetailsOverlay";
import ShareOverlay from "@/components/player/ShareOverlay";
import SubscribeOverlay from "@/components/player/SubscribeOverlay";

export default {
  props: {
    link: { type: String, required: true },
    ts: { type: Number },
    lite: { type: Boolean },
  },

  components: {
    PlayerImage,
    PlayerPlay,
    PlayerActions,
    PlayerDetails,
    PlayerEpisodes,
    DetailsOverlay,
    ShareOverlay,
    SubscribeOverlay,
  },

  data() {
    return {
      initialized: false,
      isPlaying: false,
      player: null,
      overlayToShow: null,
      episode: {},
      podcast: {},
      mobileTriggerListener: null,
      error: false,
      referer: "",
    };
  },

  methods: {
    togglePlayback() {
      this.player.togglePlay();
      this.isPlaying = this.player.playing;
    },

    launchWebsite() {
      return window.open(this.episode.sharePath);
    },

    toggleShowNotes() {
      this.overlayToShow = this.overlayToShow === "details" ? null : "details";
    },

    closeOverlay() {
      this.overlayToShow = null;
    },

    updateEpisode(episode) {
      this.episode = episode;
      this.overlayToShow = null;

      document.querySelector(".plyr__controls-row").remove();
      document.querySelector(".plyr__progress").remove();

      this.player.source = {
        type: "audio",
        title: episode.title,
        sources: [
          {
            src: episode.downloadPath,
            type: episode.mimeType,
          },
        ],
      };

      this.player.play();
      this.isPlaying = true;
    },

    setupPlayer() {
      const vm = this;
      const { primary, secondary, text } = vm.podcast.customization;

      if (primary || secondary || text) {
        let style = document.createElement("style");
        style.type = "text/css";
        let styleText = ":root {\n";
        if (primary) {
          styleText += `  --primary-color: ${primary};\n`;
        }
        if (secondary) {
          styleText += `  --secondary-color: ${secondary};\n`;
        }
        if (text) {
          styleText += `  --text-color: ${text};\n`;
        }
        styleText += "}";
        style.appendChild(document.createTextNode(styleText));
        document.head.appendChild(style);
      }

      vm.player = new Plyr(vm.$refs.player, {
        controls: vm.plyrControls,
        seekTime: 0,
        fullscreen: { enabled: false}
      });

      if (vm.ts) {
        vm.player.on("canplay", () => {
          if (vm.initialized) {
            return;
          }

          vm.player.currentTime = vm.ts;
          vm.player.play();
          vm.isPlaying = true;
          vm.initialized = true;
        });
      }

      vm.player.on("ended", () => {
        vm.overlayToShow = "subscribe";
      });

      let playbackElements = [];

      document.querySelectorAll("button[data-plyr='rewind']").forEach((el) => {
        ["click", "ontouchstart"].forEach((event) => {
          el.addEventListener(event, function(e) {
            e.preventDefault();
            vm.player.rewind(parseFloat(el.dataset.value));
          });
        });
      });

      document
        .querySelectorAll("button[data-plyr='fast-forward']")
        .forEach((el) => {
          ["click", "ontouchstart"].forEach((event) => {
            el.addEventListener(event, function(e) {
              e.preventDefault();
              vm.player.forward(parseFloat(el.dataset.value));
            });
          });
        });

      document.querySelectorAll("button[data-plyr='speed']").forEach((el) => {
        playbackElements.push(el);

        if (el.dataset.value === "1") el.classList.add("--selected");

        el.addEventListener("click", function(e) {
          playbackElements.forEach((el) => el.classList.remove("--selected"));
          e.target.classList.add("--selected");
          vm.player.speed = parseFloat(e.target.dataset.value);
        });
      });

      document
        .querySelectorAll("[data-role='mobile-trigger']")
        .forEach((el) => {
          ["click", "ontouchstart"].forEach((event) => {
            if (vm.mobileTriggerListener) return;

            vm.mobileTriggerListener = el.addEventListener(event, function(e) {
              e.preventDefault();
              document
                .querySelectorAll("[data-role='control-row']")[0]
                .classList.add("--mobile-show");

              setTimeout(() => {
                document.querySelectorAll(".player__body").forEach((el) => {
                  ["click", "ontouchstart"].forEach((event) => {
                    el.addEventListener(event, function handler(e) {
                      if (e.srcElement.classList.contains("plyr__control"))
                        return;

                      e.preventDefault();
                      document
                        .querySelectorAll("[data-role='control-row']")[0]
                        .classList.remove("--mobile-show");
                      e.currentTarget.removeEventListener(e.type, handler);
                    });
                  });
                });
              }, 100);
            });
          });
        });
    },
  },

  mounted() {
    const endpoint = this.isLatestEmbed ? Api.Routes.latestEpisodeDetails(this.guid)
            : this.isPodcastEmbed ? Api.Routes.podcastDetails(this.guid)
            : Api.Routes.episodeDetails(this.guid);

    this.referer = encodeURIComponent(
      window.location != window.parent.location
        ? document.referrer
        : document.location.href
    );

    Api.get(endpoint)
      .then((response) => {
        this.podcast = response.data.podcast;
        this.episode = this.isPodcastEmbed
          ? this.podcast.episodes[0]
          : response.data.episode;

        this.$nextTick(this.setupPlayer);
      })
      .catch((err) => {
        if (err.response.status == 404) {
          this.error = "404";
        } else if (err.response.status == 403) {
          this.error = "403";
        } else {
          this.error = true;
        }
      });
  },

  computed: {
    guid() {
      const linkParts = this.link.replace('/latest', '').split("/");
      return linkParts[linkParts.length - 1].split("?")[0];
    },

    isPodcastEmbed() {
      return this.link.includes("embed/podcast") && ! this.link.includes("latest");
    },

    isLatestEmbed() {
      return this.link.includes("latest");
    },

    hasLoaded() {
      return this.podcast.title && this.episode.title;
    },

    plyrControls() {
      return `<div class="plyr__controls-row">
        <div class="plyr__time plyr__time--current" title="Current time" aria-label="Current time">00:00</div>
        <div class="plyr__control --mobile-controls-trigger" title="Playback controls" aria-label="Playback controls" data-role="mobile-trigger">
          <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M93.747 45.596a1.015 1.015 0 00-.652-.84L81.708 40.51a33.081 33.081 0 00-2.493-6.07l5.058-11.065a1.01 1.01 0 00-.126-1.05 40.286 40.286 0 00-6.398-6.43 1.003 1.003 0 00-1.051-.13l-10.975 5.043a32.256 32.256 0 00-6.164-2.578l-4.19-11.32a1.01 1.01 0 00-.832-.653 40.139 40.139 0 00-9.05 0c-.377.042-.7.294-.831.651L40.45 18.23a32.877 32.877 0 00-6.15 2.566l-10.976-5.043a1.004 1.004 0 00-1.048.127 40.21 40.21 0 00-6.406 6.417 1.015 1.015 0 00-.128 1.053L20.8 34.413a32.588 32.588 0 00-2.498 6.083L6.91 44.73a1.012 1.012 0 00-.651.834 40.056 40.056 0 000 9.089c.042.378.294.7.651.835l11.472 4.271a32.882 32.882 0 002.46 5.912L15.73 76.879c-.158.345-.108.752.127 1.05a40.385 40.385 0 006.385 6.416 1.01 1.01 0 001.05.13l11.236-5.153a32.541 32.541 0 005.8 2.405L44.63 93.34c.146.397.524.66.945.66h8.829c.42 0 .798-.263.947-.66l4.304-11.607a32.536 32.536 0 005.805-2.4l11.22 5.154c.346.16.75.11 1.047-.126a40.102 40.102 0 006.4-6.405 1.01 1.01 0 00.13-1.05l-5.11-11.208a33.017 33.017 0 002.47-5.912l11.48-4.277c.356-.134.607-.455.65-.835a40.901 40.901 0 000-9.078zM64.42 57.546C61.71 63.29 55.853 67 49.497 67c-2.444 0-4.814-.533-7.042-1.589a16.377 16.377 0 01-8.479-9.345 16.387 16.387 0 01.613-12.612C37.3 37.711 43.16 34 49.52 34c2.44 0 4.804.532 7.027 1.581 8.229 3.89 11.76 13.742 7.874 21.965z" fill="inherit"/></svg>
        </div>
        <div class="plyr__controls-row-actions" data-role="control-row">
          <button type="button" class="plyr__control" title="Rewind 15 seconds" aria-label="Skip back" data-plyr="rewind" data-value="15">
            <svg viewBox="0 0 80 80" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><defs><path id="a" d="M0 0h80v80H0z"/></defs><path d="M49.365 75l4.53-8.22c8.617-2.866 14.874-11.003 14.874-20.526 0-11.895-9.761-21.627-21.692-21.627v14.418L29 21.023 47.077 3v14.418C62.985 17.418 76 30.394 76 46.254 76 61.346 64.214 73.827 49.365 75zM17 72H9.968V50.277H9.62L3 54.667v-6.031L9.968 44H17v28zm8-8.017h6.238c.337 1.752 2.296 2.86 4.51 2.86 2.528 0 4.635-1.732 4.635-4.492 0-2.578-2.023-4.33-4.594-4.33-2.276 0-3.603 1.288-4.109 2.195h-6.09L26.728 44h18.544v5.258H32.144l-.548 6.204h.337c.569-.886 2.508-2.337 5.795-2.337 4.91 0 9.272 3.122 9.272 8.984C47 68.173 42.406 72 35.705 72c-6.47 0-10.579-3.525-10.705-8.017z" fill-rule="nonzero" fill="inherit"/></svg>
          </button>
          <div class="plyr__playback-wrapper">
            <button type="button" class="plyr__control" title="Playback speed" aria-label="Set playback speed">
              <svg viewBox="0 0 80 80" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><defs><path id="a" d="M0 0h80v80H0z"/></defs><path d="M40.5 10C61.735 10 79 27.18 79 48.306c0 7.697-2.329 15.098-6.597 21.391l-.205.303-4.376-3.44.168-.253a32.542 32.542 0 005.408-18.001c0-18.111-14.7-32.74-32.898-32.74-18.197 0-32.898 14.629-32.898 32.74a32.542 32.542 0 005.408 18l.168.254L8.802 70l-.205-.303C4.329 63.404 2 56.003 2 48.306 2 27.18 19.265 10 40.5 10zM26.08 28.283l20.083 23.873c1.73 3.132.69 7.158-2.314 8.97-3.002 1.81-6.86.722-8.621-2.478L25 27l1.08 1.283z" stroke="inherit" stroke-width=".4" fill-rule="nonzero" fill="inherit"/></svg>
            </button>
            <div class="plyr__playback">
              <button type="button" class="plyr__control" title="Set playback speed to 0.75x" aria-label="Set playback speed to 0.75x" data-plyr="speed" data-value="0.75">0.75x</button>
              <button type="button" class="plyr__control" title="Set playback speed to 1x" aria-label="Set playback speed to 1x" data-plyr="speed" data-value="1">1x</button>
              <button type="button" class="plyr__control" title="Set playback speed to 1.25x" aria-label="Set playback speed to 1.25x" data-plyr="speed" data-value="1.25">1.25x</button>
              <button type="button" class="plyr__control" title="Set playback speed to 1.5x" aria-label="Set playback speed to 1.5x" data-plyr="speed" data-value="1.5">1.5x</button>
              <button type="button" class="plyr__control" title="Set playback speed to 2x" aria-label="Set playback speed to 2x" data-plyr="speed" data-value="2.0">2x</button>
            </div>
          </div>
          <div class="plyr__volume-wrapper" title="Volume">
            <button type="button" class="plyr__control" aria-label="Mute" data-plyr="mute">
              <svg class="icon--pressed" role="presentation">
                <use xlink:href="#plyr-muted"></use>
              </svg>
              <svg class="icon--not-pressed" role="presentation" aria-label="Volume control">
                <use xlink:href="#plyr-volume"></use>
              </svg>
            </button>
            <div class="plyr__volume">
              <input
                data-plyr="volume"
                type="range"
                min="0"
                max="1"
                step="0.05"
                value="1"
                autocomplete="off"
                aria-label="Volume"
              >
            </div>
          </div>
          <button type="button" class="plyr__control" title="Fast forward 30 seconds" data-plyr="fast-forward" data-value="30">
            <svg viewBox="0 0 80 80" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><defs><path id="a" d="M0 0h80v80H0z"/></defs><g fill-rule="nonzero" fill="inherit"><path d="M29.068 75l-4.433-8.106c-8.434-2.826-14.558-10.85-14.558-20.24 0-11.73 9.554-21.327 21.23-21.327v14.217L49 21.772 31.308 4v14.218C15.738 18.218 3 31.014 3 46.653 3 61.536 14.535 73.843 29.068 75z"/><path d="M38.77 58.467V53.77h2.727c2.059 0 3.45-1.318 3.45-3.036 0-1.795-1.503-2.998-3.432-2.998-2.114 0-3.487 1.451-3.542 3.017H32.37C32.519 46.132 35.914 43 41.738 43c5.583-.019 9.051 2.845 9.088 6.874.038 3.705-2.875 5.519-4.674 5.805v.325c2.412.229 5.36 2.1 5.398 6.167.037 5.232-4.767 7.829-9.98 7.829-6.231 0-9.496-3.647-9.57-7.81h5.527c.075 1.738 1.762 2.98 4.007 2.98 2.411 0 4.025-1.376 4.006-3.362-.018-1.87-1.465-3.341-3.932-3.341H38.77zm24.28-2.66v1.326c0 5.285 1.503 8.367 4.015 8.367 2.513 0 4.035-3.102 4.035-8.367v-1.327c0-5.245-1.503-8.306-4.035-8.306-2.512 0-4.015 3.04-4.015 8.306zm-6.9 1.304v-1.28c0-7.77 4.204-12.83 10.996-12.83C73.937 43 78 47.945 78 55.83v1.28C78 64.864 73.735 70 67.004 70c-6.73 0-10.854-5.022-10.854-12.889z"/></g></svg>
          </button>
        </div>
        <div class="plyr__time plyr__time--duration" title="Episode duration" aria-label="Duration">00:00</div>
      </div>
      <div class="plyr__progress">
        <input
          data-plyr="seek"
          type="range"
          min="0"
          max="100"
          step="0.01"
          value="0"
          aria-label="Seek"
        >
        <progress class="plyr__progress__buffer" min="0" max="100" value="0">% buffered</progress>
        <span role="tooltip" class="plyr__tooltip">00:00</span>
      </div>
    </div>`;
    },
  },
};
</script>

<style lang="scss" scoped>
@function bg-radial-gradient($variable) {
  @return unquote(
    "radial-gradient(circle 600px at 0% 48%, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.16))" +
      $variable
  );
}

@function darken-var($variable, $opacity) {
  @return unquote(
    "linear-gradient(rgba(0, 0, 0, " + $opacity + "), rgba(0, 0, 0,  " +
      $opacity + "))" + $variable
  );
}

.player {
  min-height: 170px;
  overflow: hidden;
  background: var(--secondary-color);
  border-radius: 4px;

  &.player__lite {
    min-height: 145px;
    height: 145px;

    .player__body {
      width: 100%;
    }
  }
}

.player__content {
  position: relative;
  display: flex;
  padding: 8px;
}

.player__episodes {
  max-height: 190px;
  overflow-x: hidden;
  overflow-y: auto;
  padding: 8px;
  box-shadow: inset 0 1px 4px -1px rgba(black, 0.2);
}

.player__image {
  height: 170px;
}

.player__body {
  width: calc(100% - 170px);
  padding: 8px 20px 36px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  svg mask {
    fill: var(--text-color);
  }
}

.player__details {
  display: flex;
  min-height: 3rem;
}

.player__image {
  z-index: 5;
}

.player__overlay {
  position: absolute;
  z-index: 3;
  top: 0;
  left: 0;
  background: var(--secondary-color);
  width: 100%;
  height: 100%;
  overflow-y: auto;
}

.fade-up-enter-active,
.fade-up-leave-active {
  transition: all 0.2s;
  transform: translateY(0px);
}
.fade-up-enter,
.fade-up-leave-to {
  opacity: 0;
  transform: translateY(15px);
}

.player__actions {
  position: absolute;
  z-index: 4;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 8px 24px 8px 186px;
  transition: all 0.2s ease;

  &.overlayOpen {
    padding: 4px 24px 4px 186px;
    background: var(--secondary-color);
    box-shadow: 0 -1px 1px -1px rgba(black, 0.2);
    margin-right: 16px;
  }
}

.loading-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;

  .logo {
    margin-top: 8px;
    width: 100px;
  }
}

@media screen and (max-width: $breakpoint--m) {
  .player__image {
    height: 160px;
  }
}

@media screen and (max-width: $breakpoint--s) {
  .player__image {
    position: absolute;
    height: 50%;
    bottom: 8px;

    &.overlayOpen {
      height: calc(100% - 16px);
    }
  }

  .player__actions {
    padding: 8px 24px 8px 84px;
    margin: 0 0 0 8px;

    &.overlayOpen {
      padding: 4px 24px 4px 84px;
    }
  }

  .player__body {
    width: 100%;
    padding: 8px 4px 36px 8px;
  }
}
@media screen and (max-width: $breakpoint--xs) {
  .player__actions {
    overflow-x: scroll;
  }
}
</style>

<style lang="scss">
// Plyr Styles
#player {
  .plyr--audio,
  .plyr__controls {
    background: transparent;
  }

  .plyr--full-ui input[type="range"] {
    color: var(--primary-color);
    &:hover {
      color: var(--text-color);
      cursor: pointer;
    }
  }

  .plyr__tab-focus {
    box-shadow: none;
  }

  .plyr__progress__buffer {
    background: white;
    box-shadow: 0 1px 2px rgba(black, 0.2);
  }

  .plyr__controls-row {
    position: relative;
    top: 5px;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    min-height: 30px;
  }

  .plyr__time {
    font-size: 11px;
    color: var(--text-color);
    opacity: 0.5;
    transition: opacity 0.2s ease;

    &:before {
      content: "";
    }
  }

  .plyr__controls-row-actions {
    display: flex;
    position: relative;
    top: -4px;
    opacity: 0.5;
    transition: opacity 0.2s ease;
  }

  .plyr__volume-wrapper,
  .plyr__playback-wrapper {
    position: relative;

    &:hover {
      .plyr__volume,
      .plyr__playback {
        display: flex;
      }
    }
  }

  .plyr__control {
    display: flex;

    &:hover {
      background: var(--primary-color);
      color: var(--secondary-color);

      svg {
        color: white;
      }
    }

    img {
      height: 20px;
      width: 20px;
    }

    svg {
      color: var(--text-color);
    }

    &.--mobile-controls-trigger {
      display: none;
    }
  }

  .plyr__volume,
  .plyr__playback {
    display: none;
    position: absolute;
    z-index: 1;
    left: 0;
    top: -32px;
    min-width: 100px;
    animation: expand-in 0.2s ease;
    transform-origin: 0 0;
    height: 32px;
    background: white;
    border-radius: 3px;
    box-shadow: 0 1px 2px rgba(black, 0.2);

    input[type="range"] {
      width: 100%;
      padding: 5px;
      margin-left: 0;
    }
  }

  .plyr__playback {
    .plyr__control {
      font-size: 14px;
      font-weight: 500;
      line-height: 1rem;

      &.--selected {
        background: var(--primary-color);
        color: white;
      }
    }
  }
}

@keyframes expand-in {
  from {
    opacity: 0;
    transform: scaleX(0.8);
  }

  to {
    opacity: 1;
    transform: scaleX(1);
  }
}

@media screen and (min-width: $breakpoint--s) {
  #player {
    .player__body:hover {
      .plyr__controls-row-actions {
        opacity: 1;
      }
    }
  }
}

@media screen and (max-width: $breakpoint--s) {
  #player {
    .plyr {
      padding-left: 80px;
    }

    .plyr__control {
      &.--mobile-controls-trigger {
        display: block;
        opacity: 0.7;
      }
    }

    .plyr__controls-row-actions {
      display: none;
      opacity: 1;
      position: absolute;
      left: 50%;
      margin-left: -64px;
      background: var(--secondary-color);
      z-index: 4;
      border-radius: 4px;
      box-shadow: 0 6px 12px rgba(black, 0.2);

      &.--mobile-show {
        display: flex;
      }
    }

    .plyr__playback,
    .plyr__volume {
      left: -32px;
    }
  }
}
</style>
